import React from 'react';
import { BringzzText, BringzzIcon } from "@bringzz/components";
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'context/NavigationContext';

const GeneralOptions = () => {
    const { t } = useTranslation();
    const { navigate } = useNavigation();

    const handleProductsClick = () => {
        navigate('/search/products');
    };

    const handleSubstancesClick = () => {
        navigate('/search/substances');
    }

    return (
        <div className='mt-2 py-2 px-6 mx-2 bg-white rounded-xl'>
            <div className='flex items-center h-12 justify-between cursor-pointer' onClick={handleProductsClick}>
                <div className='flex space-x-3 items-center'>
                    <BringzzIcon size="16" icon="IconScan" folder="LineIcons" />
                    <BringzzText tag='h3' className='font-normal'>{t('component.search.options.products')}</BringzzText>
                </div>
                <BringzzIcon size="16" icon="IconChevronRight" folder="LineIcons" />
            </div>

            <div className='flex items-center h-12 justify-between cursor-pointer' onClick={handleSubstancesClick}>
                <div className='flex space-x-3 items-center'>
                    <BringzzIcon size="16" icon="IconScan" folder="LineIcons" />
                    <BringzzText tag='h3' className='font-normal'>{t('component.search.options.active_ingredient')}</BringzzText>
                </div>
                <BringzzIcon size="16" icon="IconChevronRight" folder="LineIcons" />
            </div>

        </div>
    );
};

export default GeneralOptions;